import { SAVE_CUSTOM_CONTRACT_FILD } from "./ActionConstants";

export function saveCustomContractField(data) {
    return { type: SAVE_CUSTOM_CONTRACT_FILD, data }
}